"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonStatuses = void 0;
var AddonStatuses;
(function (AddonStatuses) {
    AddonStatuses["ACTIVE"] = "ACTIVE";
    AddonStatuses["INACTIVE"] = "INACTIVE";
})(AddonStatuses || (exports.AddonStatuses = AddonStatuses = {}));
//# sourceMappingURL=addon-statuses.enum.js.map